import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}tipo_incapacidad`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}tipo_incapacidad/get/list`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}tipo_incapacidad/${id}`);
  return response;
};
const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}tipo_incapacidad`, payload);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}tipo_incapacidad`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}tipo_incapacidad/${id}`);
  return response;
};

const getLeaveTypesOdoo = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_leave_type/list`);
  return response;
}

export { getAll, getList, getById, insert, update, drop, getLeaveTypesOdoo };
